import {GetterTree} from "vuex";
import {ProviderConnectionState} from "@/store/settings/provider_connections/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<ProviderConnectionState, RootState> = {
  providerConnections:state => state.providerConnections,
  providerConnectionStatus:state => state.providerConnectionStatus
}